"use client";

import { useEffect, useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import { apiFetchJson } from "@/lib/api";

export function RequireBeta({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const pathname = usePathname();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await apiFetchJson<{ beta_access: boolean }>("/beta/status");
        if (!cancelled) {
          if (!data?.beta_access && pathname !== "/beta-required") {
            router.replace("/beta-required");
          } else {
            setChecking(false);
          }
        }
      } catch (e) {
        if (!cancelled) {
          // On error, default to blocking and show info page
          if (pathname !== "/beta-required") router.replace("/beta-required");
          else setChecking(false);
        }
      }
    })();
    return () => { cancelled = true; };
  }, [router, pathname]);

  if (checking) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-sm text-muted-foreground">
        Checking beta access…
      </div>
    );
  }

  return <>{children}</>;
}

